import offTime from './offTime.js';
import group from './group.js';
import tour from './tour.js';
import assignment from './assignment.js';
import daysOffRequest from './daysOffRequest.js';


const contextMenuArrays = {
  offTime: Object.values(offTime),
  group: Object.values(group),
  tour: Object.values(tour),
  assignment: Object.values(assignment),
  daysOffRequest: Object.values(daysOffRequest)
};

export default contextMenuArrays;
